/* Galerie native : swipe, clavier, miniatures, éditeur Shopify. */
if (!customElements.get('template-landing-hero')) {
  customElements.define('template-landing-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.tlh__track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-index]')];
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.index = 0;
      this.previous?.addEventListener('click', () => this.go(this.index - 1), options);
      this.next?.addEventListener('click', () => this.go(this.index + 1), options);
      this.thumbs.forEach((button, i) => button.addEventListener('click', () => this.go(i), options));
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(next);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const width = this.track.clientWidth;
          if (width) this.update(Math.round(this.track.scrollLeft / width));
        });
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (i >= 0) this.go(i, false);
        const details = event.target.closest('.tlh__question');
        if (details) details.open = true;
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.resizeObserver.observe(this.track);
      this.update(0);
    }
    go(index, animate = true) {
      const bounded = Math.max(0, Math.min(index, this.slides.length - 1));
      const smooth = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: bounded * this.track.clientWidth, behavior: smooth ? 'smooth' : 'instant' });
    }
    update(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.thumbs.forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      const active = this.thumbs[this.index];
      if (active) {
        const row = active.parentElement;
        const left = active.offsetLeft - row.offsetLeft;
        if (left < row.scrollLeft) row.scrollLeft = left;
        else if (left + active.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollLeft = left + active.offsetWidth - row.clientWidth;
      }
      this.querySelector('[data-status]').textContent = `Image ${this.index + 1} sur ${this.slides.length}`;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
